module.exports = __webpack_public_path__ + "a8288609f7289c49d08ada8a2a09f506.png";